export const SET_LOC_TYPE = "SET_LOC_TYPE";
export const GET_LOC_TYPE = "GET_LOC_TYPE";
export const SET_LOC_TYPE_QUES = "SET_LOC_TYPE_QUES";
export const GET_LOC_TYPE_QUES = "GET_LOC_TYPE_QUES";